// extracted by mini-css-extract-plugin
export default {"container":"GradesCell__container___yI__y","tooltipSvgContainer":"GradesCell__tooltipSvgContainer___XClQb","svgContainer":"GradesCell__svgContainer___v8K_6"};